import styled from 'styled-components';
import { _ } from '_locales';
import React from 'react';

const Container = styled.div`
  padding: 15px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const Circle = styled.div`
  width: 23px;
  height: 23px;
  min-width: 23px;
  min-height: 23px;
  border: 1px solid ${process.env.REACT_APP_COLOR_GRAY};
  background-color: white;
  margin-right: 10px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.selected {
    &:before {
      content: '';
      width: 13px;
      height: 13px;
      background-color: ${process.env.REACT_APP_COLOR_RC_ACTIONS};
      border-radius: 50%;
    }
  }
`;

const Oops = styled.div`
  display: flex;
  justify-content: space-between;
  background-image: url();
  background-position: right center;
  background-size: 20px;
  background-repeat: no-repeat;
  color: ${process.env.REACT_APP_COLOR_RC_RED};
`;

const Yes = styled.div`
  display: flex;
  justify-content: space-between;
  background-image: url();
  background-position: right center;
  background-size: 20px;
  background-repeat: no-repeat;
  color: ${process.env.REACT_APP_COLOR_RC_GREEN};
`;

const QuizOption = ({
  onClick,
  children,
  selected,
  value,
  nuetral,
  state,
  isResult
}) => (
  <div>
    <Container onClick={() => {
      if (onClick) onClick(value);
      return null;
    }}
    >
      <Circle className={selected ? 'selected' : ''} />
      <h3>
        {children}
      </h3>
    </Container>
    {
      isResult
        && !nuetral
        ? (
          <h3>
            {
              !nuetral
                && state
                && state === 'wrong'
                ? (
                  <Oops>
                    {/* {__('app.oops_wrong_answer') */}
                    {' '}
                    oops_wrong_answer

                  </Oops>
                )
                : (
                  <Yes>
                    {
                      // __('app.here_is_the_right_answer')
                      'here_is_the_right_answer'
                    }
                  </Yes>
                )
            }
          </h3>
        ) : null
    }
  </div>
);

export default QuizOption;
